import EcheancierPret from '../EcheancierPret';

const Tab5 = (props: { form?: any }) => <EcheancierPret form={props.form} />;

export default Tab5;
